import { InitialCausalityHistorical } from '../../../../../shared/types/typifications/initialCausality';

export interface InitialCausalityHistoricalProps {
    historical: InitialCausalityHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    active: 'Estado',
    category: 'Categoria',
    consequence: 'Consecuencia',
    createdAt: 'Fecha de creación',
    motive: 'Motivo',
    motiveDescription: 'Descripción Motivo de Quejas SFC',
    motiveName: 'Nombre Motivo de Queja SFC',
    name: 'Nombre',
    observationV1: 'Observación Versión 1',
    process: 'Proceso',
    product: 'Producto',
    risk: 'Riesgo',
    riskId: 'NO. Riesgo',
    riskImpact: 'Impacto del riesgo',
    sfcMotive: 'Motivo [SECTOR - FASECOLDA]',
    sfcMotiveClaim: 'Motivo de reclamación SFC',
    sfcMotiveIdComplaint: 'Código motivo quejas sector SFC(Nuevo)',
    sfcMotiveIdComplaintOld: 'Código motivo quejas sector SFC(Anterior)',
    sfcSubaccount: 'Subcuenta SFC',
    sfcSubmotive: 'Submotivo [SECTOR - FASECOLDA]',
    submotive1: 'Submotivo 1',
    submotive2: 'Submotivo 2',
    submotive3: 'Submotivo 3',
    submotive4: 'Submotivo 4',
    subprocess: 'Subproceso',
    technicalBranch: 'Ramo técnico',
    typeComplaint: 'Tipo de queja',
    typeMotive: 'Tipo de motivo',
    typePqr: 'Tipo Pqr',
    unifiedProduct: 'Producto unificado',
};
